function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Skeleton, List, Typography, notification, Drawer } from "antd";
import moment from "moment";
import { Excel } from "antd-table-saveas-excel";
import Common from "./includes/Common";
import { Download, PrinterFill, PencilSquare, CheckCircleFill } from "react-bootstrap-icons";
import Moment from 'react-moment';
import EditCustomer from "./forms/EditCustomer";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import OrderReceipt from "./OrderReceip";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var CashierTransactionsList = function CashierTransactionsList(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? Common.currentUser : _ref$user,
      _ref$dataChanged = _ref.dataChanged,
      dataChanged = _ref$dataChanged === void 0 ? false : _ref$dataChanged,
      _ref$from = _ref.from,
      from = _ref$from === void 0 ? moment().startOf('day').format() : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === void 0 ? moment().endOf('day').format() : _ref$to;

  var _useState = useState(from),
      _useState2 = _slicedToArray(_useState, 2),
      sfrom = _useState2[0],
      setSfrom = _useState2[1];

  var ref = useRef();

  var _useState3 = useState(to),
      _useState4 = _slicedToArray(_useState3, 2),
      sto = _useState4[0],
      setSto = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      listOfBills = _useState6[0],
      setListOfBills = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      billsArrayData = _useState8[0],
      setBillsArrayData = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      rdata = _useState10[0],
      setRdata = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      isDataLoading = _useState12[0],
      setIsDataLoading = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      currentPatient = _useState14[0],
      setCurrentPatient = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      currentItems = _useState16[0],
      setCurrentItems = _useState16[1];

  var _useState17 = useState(user == null ? Common.currentUser : user),
      _useState18 = _slicedToArray(_useState17, 2),
      currentUser = _useState18[0],
      setCurrentUser = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      showEditCustomer = _useState20[0],
      setShowEditCustomer = _useState20[1];

  var _useState21 = useState(0),
      _useState22 = _slicedToArray(_useState21, 2),
      currentAmount = _useState22[0],
      setCurrentAmount = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showReceipt = _useState24[0],
      setShowReceipt = _useState24[1];

  var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      selectedBill = _useState26[0],
      setSelectedBill = _useState26[1];

  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };

  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date, row, index) {
      return /*#__PURE__*/_jsx(Moment, {
        date: date,
        format: "DD/MM/YYYY"
      });
    },
    key: "date"
  }, {
    title: "Patient/ETS",
    dataIndex: "patient",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "patient"
  }, {
    title: "Type",
    dataIndex: "type",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "type"
  }, {
    title: "Acte (s)",
    dataIndex: "acte",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "acte"
  }, {
    title: "Montant",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "amount"
  }, {
    title: "Cash",
    dataIndex: "cash",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "cash"
  }, {
    title: "Ets",
    dataIndex: "ent",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "ent"
  }, {
    title: "",
    dataIndex: "print",
    render: function render(obj) {
      if (obj.type == "b") return /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          setRdata([]);
          setCurrentItems(obj.items);
          setSelectedBill(obj.bill);
          obj.bill.bill_items.forEach(function (e) {
            setRdata(function (prev) {
              return [].concat(_toConsumableArray(prev), [e.business_account_medical_item.label + " " + e.business_account_medical_item.base_price.toLocaleString('fr') + " GNF"]);
            });
          });
          setCurrentAmount(obj.to_be_paid);
          setShowReceipt(true);
          setCurrentPatient(obj.patient);
        },
        children: /*#__PURE__*/_jsx(PrinterFill, {
          size: 27
        })
      });else return {
        children: /*#__PURE__*/_jsx("b", {
          children: obj.amount
        })
      };
    },
    key: "print"
  }, {
    title: "",
    dataIndex: "edit",
    render: function render(obj) {
      if (obj.type == "e") return /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          setCurrentPatient(obj.patient);
          setShowEditCustomer(true);
        },
        children: /*#__PURE__*/_jsx(PencilSquare, {
          size: 27
        })
      });else return {
        children: /*#__PURE__*/_jsx("b", {
          children: obj.amount
        })
      };
    },
    key: "edit"
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setCurrentUser(user == null ? Common.currentUser : user);
    axios.get(Common.baseApiUrl + "getuserbills/" + from + "/" + to + "/" + currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setListOfBills(response.data.billsdata);
        setBillsArrayData([]);
        var totalDue = 0;
        var cash_amount = 0;
        var post_paid_amount = 0;
        response.data.billsdata.forEach(function (b) {
          var iar = [];
          cash_amount += eval(b.patient_part);
          post_paid_amount += eval(b.company_part);
          b.bill_items.forEach(function (i) {
            if (i.business_account_medical_item != null) {
              iar.push(i.business_account_medical_item.label); //totalDue += i.business_account_medical_item.base_price;     
            } //cash_amount += b.patient_part;     
            //post_paid_amount += b.company_part;       

          });
          totalDue += eval(b.total_amount);
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: b.id,
              date: b.created_at,
              type: b.company_id == null ? "Part" : "ENT",
              patient: b.company_id == null ? b.customer.firstname + " " + b.customer.lastname : b.company.label + "(" + b.company.rate.toString() + "%)",
              acte: iar.join(", "),
              amount: eval(b.total_amount),
              cash: eval(b.patient_part).toLocaleString("Fr"),
              ent: eval(b.company_part).toLocaleString("Fr"),
              print: {
                type: "b",
                patient: b.customer,
                bill: b,
                to_be_paid: b.patient_part,
                items: b.bill_items
              },
              edit: {
                type: "e",
                patient: b.customer,
                bill: b
              }
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged, user]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [currentPatient != null && currentItems.length > 0 && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "reprintid",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '130px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/emgl.png",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Date:"
        }), " ", /*#__PURE__*/_jsx(Moment, {
          date: currentPatient.created_at,
          format: "DD/MM/YYYY H:m"
        })]
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", currentPatient.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", currentPatient.firstname + " " + currentPatient.lastname]
      }), /*#__PURE__*/_jsx(List, {
        header: /*#__PURE__*/_jsx("div", {
          children: "Article(s)"
        }),
        footer: /*#__PURE__*/_jsx("b", {
          children: "TOTAL (GNF) " + currentAmount.toLocaleString("Fr")
        }),
        bordered: true,
        dataSource: currentItems,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(Typography.Text, {
              mark: true,
              children: item.business_account_medical_item.label + " - " + item.business_account_medical_item.base_price.toLocaleString("Fr")
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), currentPatient.company != null && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        banner: true,
        message: "Prise en charge de " + currentPatient.company.rate.toString() + "% par " + currentPatient.company.label
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Kissidougou, Korodou, Secteur II - Route Nationale N\xB01 - Tel: 622342787/621128638"
        })
      })]
    }), /*#__PURE__*/_jsx(Button, {
      block: true,
      disabled: billsArrayData.length == 0,
      type: "primary",
      onClick: handleExport,
      style: {
        background: "#34C482"
      },
      icon: /*#__PURE__*/_jsx(Download, {
        size: 28
      }),
      children: /*#__PURE__*/_jsx("b", {
        children: "EXPORTER AU FORMAT EXCEL"
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), !isDataLoading ? /*#__PURE__*/_jsx(Table, {
      size: "small",
      columns: cols,
      bordered: true,
      sticky: true,
      loading: isDataLoading,
      dataSource: billsArrayData,
      pagination: false
    }) : /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), currentPatient != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LES INFOS PATIENT"
      }),
      width: "420px",
      open: showEditCustomer,
      onClose: function onClose() {
        setShowEditCustomer(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(EditCustomer, {
        customer: currentPatient,
        handleUpdate: function handleUpdate() {
          setShowEditCustomer(false);
          notification.success({
            message: "Ok!",
            description: 'Opération reussie'
          });
        }
      })
    }), currentItems.length > 0 && currentAmount && selectedBill && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          size: 30
        }), " RECU"]
      }),
      width: "280px",
      open: showReceipt,
      onClose: function onClose() {
        setShowReceipt(false);
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsx("div", {
        ref: ref,
        style: {
          textAlign: 'center'
        },
        id: "printdiv",
        children: /*#__PURE__*/_jsx(OrderReceipt, {
          createdBill: selectedBill,
          createdValues: currentPatient,
          discount: selectedBill.discount,
          receipAmount: currentAmount,
          isPdaActive: false,
          rdata: rdata,
          currentCompany: currentPatient.company
        })
      })
    })]
  });
};

export default CashierTransactionsList;